import { default as ActivitiesUsers } from './ActivitiesUsers'
import { default as SupportedByUsers } from './SupportedByUsers'

export const Overlays = {
  ActivitiesUsers,
  SupportedByUsers,
}

export { default } from './Overlay'
